/* eslint-disable */
import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { MaterialReactTable } from "material-react-table";

//import url and gateway methods
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import { commonHeaderLinkLists } from "helper/PatientManagementHelper/PatientManagementHelper";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import NursingHeader from "./Header/NursingHeader";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import { assetImages } from "constants";
import { mergeListById } from "helper/Common/CommonHelper";
import { removeTagHandler } from "helper/TagHelper/TagHelper";
import AddLabelModal from "components/Common/Modal/AddLabelModal";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import NursingFilterPopup from "./Popup/NursingFilterPopup";
import SaveNursingPopup from "components/Common/Popup/SaveNursingPopup";

const NursingListBody = () => {
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");

  const [isLoading, setIsLoading] = useState(false);
  const [nursingList, setNursingList] = useState([]);

  // json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);
  const [isFilterReset, setIsFilterReset] = useState(false);
  const [reloadData, setReloadData] = useState(false);

  const [rowSelection, setRowSelection] = useState({});
  const [selectedNursingIds, setSelectedNursingIds] = useState([]);
  const [selectedNursingId, setSelectedNursingId] = useState(null);
  const [selectedTagId, setSelectedTagId] = useState(null);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const [isDataReady, setIsDataReady] = useState(false);

  //function for get all nursing records
  const getAllNursing = async () => {
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_NURSING + `?token=${token}`;

      if (jsonFilterQuery.length > 0) {
        // Sanitize the jsonFilterQuery
        const sanitizedQuery = jsonFilterQuery.map((filter) => {
          if (
            (filter.operator === "includes" ||
              filter.operator === "excludes") &&
            Array.isArray(filter.value)
          ) {
            return {
              ...filter,
              value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
            };
          }
          return filter;
        });

        requestUrl = requestUrl + `&filters=${JSON.stringify(sanitizedQuery)}`;
      }

      console.log("requestUrl in get all nursing", requestUrl);

      const response = await getData(requestUrl);

      setIsLoading(false);
      if (response.status) {
        setMessageType("success");
        setNursingList(response.data);
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setIsLoading(false);
      setShowAlert(true);
    }
  };

  //function for bulk delete nursing
  const deleteBulkNursingHandler = async () => {
    if (selectedNursingIds.length > 0) {
      try {
        const nursingListToBeDelete = nursingList.filter((item) =>
          selectedNursingIds.includes(item._id)
        );

        let apiData = {
          nursingtasklist: nursingListToBeDelete,
        };

        let requestURL =
          url.API_BASE_URL + url.API_DELETE_BULK_NURSING + `?token=${token}`;

        const response = await putData(requestURL, apiData);

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setNursingList((prevList) =>
              prevList.filter((item) => !selectedNursingIds.includes(item._id))
            );

            setSelectedNursingIds([]);
            setRowSelection({});
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one nursing");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //function for remove tag from nursing
  const removeTagFromNursing = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_NURSING;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      if (data) {
        afterActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedNursingId(null);
      }, 1000);
    }
  };

  //function for after any action
  const afterActionClose = (data = []) => {
    setTimeout(() => {
      setNursingList((prevList) => mergeListById(prevList, data));
    }, 1000);
  };

  const resetFilterData = () => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
    setRowSelection({});
    setSelectedNursingIds([]);
  };

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getAllNursing();
      setIsDataReady(true);
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    if (reloadData) {
      getAllNursing();
      setReloadData(false);
      setIsDataReady(true);
    }
  }, [reloadData]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: "Actions",
        Cell: ({ row }) => (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#saveNursingOffCanvas"
            aria-controls="saveNursingOffCanvas"
            onClick={() => {
              setSelectedNursingId(row.original._id);
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        ),
        enableColumnActions: false,
        enableColumnDragging: false,
        enableSorting: false,
      },
      {
        accessorKey: "title",
        header: "Title",
        size: 200,
      },
      {
        accessorKey: "tagstring",
        header: t("Label"),
        size: 200,
        Cell: ({ row }) => (
          <div className="label-wrapper py-1">
            <div className="d-flex gap-2">
              <div
                className={
                  row.original.taglist.length > 0
                    ? "label-container flex-grow-1"
                    : "d-none"
                }
              >
                <ul
                  className="d-flex flex-wrap gap-2 m-0 p-0"
                  style={{ listStyle: "none" }}
                >
                  {row.original.taglist &&
                    row.original.taglist.map((tag, index) => (
                      <li key={index} className="d-inline-flex">
                        <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                          <span className="badge-text fs-xs fw-medium me-1">
                            {tag.title}
                          </span>
                          <Link
                            to="#"
                            className={`${
                              tag.moderator.toString() ===
                                userInfo._id.toString() ||
                              userInfo.role.slug === "ADMIN" ||
                              userInfo.role.slug === "SUPER_ADMIN"
                                ? "d-block"
                                : "d-none"
                            }`}
                            onClick={() => {
                              setSelectedTagId(tag._id);
                              setSelectedNursingId(row.original._id);
                              removeTagFromNursing([tag._id], row.original._id);
                            }}
                          >
                            {selectedTagId &&
                            selectedTagId === tag._id &&
                            selectedNursingId &&
                            selectedNursingId === row.original._id ? (
                              <div
                                className="spinner-border spinner-border-sm text-primary ms-1"
                                role="status"
                                style={{ height: "12px", width: "12px" }}
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            ) : (
                              <span
                                className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                                style={{ cursor: "pointer" }}
                              >
                                cancel
                              </span>
                            )}
                          </Link>
                        </div>
                      </li>
                    ))}
                </ul>
              </div>
              <button
                className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
                style={{ width: "24px", height: "24px" }}
                data-bs-toggle="modal"
                data-bs-target="#addLabelModal"
                onClick={() => setSelectedNursingIds([row.original._id])}
              >
                <span
                  className="material-symbols-outlined text-primary"
                  style={{ fontSize: "16px" }}
                >
                  add
                </span>
              </button>
            </div>
          </div>
        ),
      },
      {
        header: "Patient",
        accessorKey: "patientname",
        size: 250,
        Cell: ({ row }) => (
          <div className="owner border-bottom-0 d-flex align-items-center gap-1">
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.patientimage === ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.patientimage
              }
              alt="Patient"
            />
            <p>
              <span className="d-block">{row.original.patientname}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Doctor",
        accessorKey: "doctorname",
        size: 250,
        Cell: ({ row }) => (
          <div className="owner border-bottom-0 d-flex align-items-center gap-1">
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.doctorimage === ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.doctorimage
              }
              alt="Nurse"
            />
            <p>
              <span className="d-block">{row.original.doctorname}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Clinic",
        accessorKey: "clinicname",
        size: 250,
        Cell: ({ row }) => (
          <div className="owner border-bottom-0 d-flex align-items-center gap-1">
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.clinicimage === ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.clinicimage
              }
              alt="Clinic"
            />
            <p>
              <span className="d-block">{row.original.clinicname}</span>
            </p>
          </div>
        ),
      },
      {
        accessorKey: "nursenames",
        header: t("Nurses"),
        size: 250,
        Cell: ({ row }) =>
          row.original.nurselist.map((nurse, index) => (
            <div
              className="owner border-bottom-0 d-flex gap-1 mb-1"
              key={index}
            >
              <img
                className="rounded-circle"
                height={15}
                width={15}
                src={
                  nurse.image == ""
                    ? assetImages.defaultUser
                    : url.SERVER_URL + nurse.image
                }
                alt="Babcock"
              />

              <p>
                <span className="d-block">{nurse.fullname}</span>
              </p>
            </div>
          )),
      },
      {
        accessorKey: "taskpriority",
        header: t("Priority"),
      },
      {
        header: "Scheduled Date",
        accessorKey: "taskstartdate",
      },
    ],
    [selectedTagId, selectedNursingId]
  );

  const columnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ];

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );
    if (selectedIdsArray.length > 0) {
      setSelectedNursingIds(selectedIdsArray);
    } else {
      setSelectedNursingIds([]);
    }
  }, [rowSelection]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    (moduleAccess.includes("MOD_PATIENT_MANAGEMENT") &&
      moduleAccess.includes("MOD_NURSING_MANAGEMENT"))
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderLinkLists(t)}
            activeOption={t("Nursing")}
          />
          <div className="container-fluid px-lg-5">
            <NursingHeader
              reloadList={resetFilterData}
              selectedItemIds={selectedNursingIds}
              jsonFilterQuery={jsonFilterQuery}
            />

            {isLoading || !isDataReady ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns}
                  data={nursingList}
                  enableGrouping
                  enableRowSelection
                  getRowId={(row) => row._id}
                  onRowSelectionChange={setRowSelection}
                  state={{ rowSelection, columnOrder }}
                  initialState={{ rowSelection, columnOrder }}
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50,
                  }}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                />
              </div>
            )}

            <SaveNursingPopup
              afterActionClose={afterActionClose}
              selectedNursingId={selectedNursingId}
              setSelectedNursingId={setSelectedNursingId}
              setShowAlert={setShowAlert}
              setAlertMessage={setAlertMessage}
              setMessageType={setMessageType}
            />

            <NursingFilterPopup
              setJsonFilterQuery={setJsonFilterQuery}
              reloadList={resetFilterData}
              moduleSlug="nursing"
              isFilterReset={isFilterReset}
              setIsFilterReset={setIsFilterReset}
              columns={columns}
            />

            <AddLabelModal
              moduleName="nursing"
              selectedIds={selectedNursingIds}
              afterTagModalClose={afterActionClose}
              setShowAlert={setShowAlert}
              setAlertMessage={setAlertMessage}
              setMessageType={setMessageType}
              onModalClose={() => {
                setRowSelection({});
                setSelectedNursingIds([]);
              }}
            />

            <DeleteWarningModal
              moduleName={"Nursing"}
              onDelete={deleteBulkNursingHandler}
              onCancelDelete={() => {
                setRowSelection({});
                setSelectedNursingIds([]);
              }}
            />

            {showAlert && (
              <AlertNotification
                showAlert={showAlert}
                message={alertMessage}
                alertType={messageType}
                onClose={onAlertClose}
              />
            )}
          </div>
        </section>
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default NursingListBody;
